import React, { FunctionComponent } from 'react';
import { Dimensions, Image, ImageSourcePropType, StyleSheet, Text, View } from 'react-native';
import GroupWorkoutBackground from '../assets/images/group-workout-background.png';
import FBLogo from '../assets/images/logo-black.png';
import NutritionBackground from '../assets/images/nutrition-background1.png';
import TrackingBackground from '../assets/images/tracking-background1.png';
import WelcomeBackground from '../assets/images/welcome2-background.png';
import WorkoutBackground from '../assets/images/workout-background1.png';
import { Slider, SliderImage } from '../ui';

import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
const { width } = Dimensions.get('window');

interface IProps {
  t: (s: string) => string;
  fixedContent?: JSX.Element;
  inviterImageSource?: ImageSourcePropType;
}

const SliderHeader = ({ source, header }) => {
  return (
    <View style={styles.slideContainer}>
      <SliderImage source={source} />
      <View style={styles.detailContainer}>
        <View style={styles.headerContainer}>
          <Text style={[Theme.textStyle.heading, styles.headerText]}>
            {header}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const HomeInviteCarousel: FunctionComponent<IProps> = ({
  t,
  fixedContent,
  inviterImageSource,
}) => {
  const firstSlideImageSource = inviterImageSource ?? WelcomeBackground;
  return (
    <Slider fixedContent={fixedContent} containerStyle={styles.slider}>
        <View style={styles.slideContainer}>
          <SliderImage source={firstSlideImageSource} />
          <View style={styles.detailContainer}>
            <Image source={FBLogo} style={styles.logo} />
          </View>
        </View>
      <SliderHeader source={WorkoutBackground} header={t('workoutHeader')} />
      <SliderHeader
        source={NutritionBackground}
        header={t('nutritionHeader')}
      />
      <SliderHeader source={TrackingBackground} header={t('trackingHeader')} />
      <SliderHeader source={GroupWorkoutBackground} header={t('groupHeader')} />
    </Slider>
  );
};

const styles = StyleSheet.create({
  detailContainer: {
    alignItems: 'center',
    paddingHorizontal: defaultScale(25),
    marginBottom: defaultScale(20),
    marginTop: defaultScale(20),
  },
  headerContainer: {
    justifyContent: 'center',
    height: defaultScale(60),
  },
  slideContainer: {
    width,
    height: '100%',
  },
  logo: {
    width: defaultScale(180),
    height: defaultScale(60),
    resizeMode: 'contain',
  },
  headerText: {
    paddingTop: defaultScale(20),
  },
  slider: {
    flex: 7,
  },
});
